import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ChevronWrapper, CollapseWrapper, SectionTitle } from 'src/ui/components/collapse/sports/01/Collapse.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

interface CollapsePropsType {
    className?: string;
    dataTest?: string;
    handleToggle: (e?: React.SyntheticEvent) => void;
    isOpen: boolean;
    title: React.ReactNode;
}

/**
 * This component will be used for:
 * - **main sections**
 * on the home page
 */
export const Collapse = observer(
    'Collapse',
    ({ title, className, handleToggle, isOpen, dataTest }: CollapsePropsType): JSX.Element => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;

        const { sportsbookVariant } = configState.componentVariants;
        return (
            <CollapseWrapper
                variant={sportsbookVariant}
                data-test={dataTest}
                isOpen={sportsbookVariant === DefaultComponentVariantType.SECONDARY ? true : isOpen}
                onClick={sportsbookVariant === DefaultComponentVariantType.SECONDARY ? undefined : handleToggle}
                className={className}
            >
                {sportsbookVariant === DefaultComponentVariantType.SECONDARY ? null : (
                    <ChevronWrapper position={isOpen ? 'up' : 'right'} />
                )}
                <SectionTitle
                    data-test='section-title'
                    variant={sportsbookVariant}
                >
                    {title}
                </SectionTitle>
            </CollapseWrapper>
        );
    }
);
